/**
 * 分享卡片主题配置
 * 固定使用深色主题，值来自 src/styles/theme.css 的 .dark 部分
 * 确保分享图片有统一的品牌视觉
 */
export const SHARE_CARD_THEME = {
  // ============ 颜色 ============
  // 基础色
  background: '#1c2433', // --background (dark)
  foreground: '#e5e5e5', // --foreground (dark)

  // 卡片
  card: '#2a3040', // --card (dark)
  cardForeground: '#e5e5e5', // --card-foreground (dark)

  // 主色（品牌色）
  primary: '#e05d38', // --primary
  primaryForeground: '#ffffff', // --primary-foreground

  // 次要/静音色
  muted: '#2a303e', // --muted (dark)
  mutedForeground: '#a3a3a3', // --muted-foreground (dark)

  // 边框
  border: '#3d4354', // --border (dark)

  // 消息气泡
  userBubble: '#86a7c8', // primary 25% 透明度
  aiBubble: 'rgba(255, 255, 255, 0.08)', // 白色 8% 透明度

  // 分隔线
  divider: 'rgba(255, 255, 255, 0.1)',

  // 二维码
  qrBackground: '#ffffff',
  qrForeground: '#1c2433', // 与 background 相同

  // ============ 圆角 ============
  // --radius: 0.75rem = 12px
  radiusLg: 12, // --radius-lg (0.75rem)
  radiusMd: 10, // --radius-md (0.75rem - 2px)
  radiusSm: 8, // --radius-sm (0.75rem - 4px)

  // ============ 字体 ============
  fontSans: 'Inter, system-ui, -apple-system, sans-serif', // --font-sans
  fontSerif: '"Source Serif 4", Georgia, serif', // --font-serif
  fontMono: '"JetBrains Mono", monospace', // --font-mono

  // ============ 字号 ============
  fontSizeXs: 10,
  fontSizeSm: 11,
  fontSizeBase: 12,
  fontSizeMd: 14,
  fontSizeLg: 18,

  // ============ 间距 ============
  // --spacing: 0.25rem = 4px
  spacing: 4,
  spacingSm: 8,
  spacingMd: 12,
  spacingLg: 16,
  spacingXl: 20,
  spacing2xl: 24,
} as const

// 类型导出
export type ShareCardTheme = typeof SHARE_CARD_THEME
